<template>
  <router-view />
</template>

<script>
export default {
  mounted() {
    const { VUE_APP_TITLE, VUE_APP_DESCRIPTION } = process.env
    if (VUE_APP_TITLE) document.title = VUE_APP_TITLE

    if (VUE_APP_DESCRIPTION)
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', VUE_APP_DESCRIPTION)
  }
}
</script>

<style lang="scss">
// Import Bulma and Buefy styles
@import '~bulma';
@import '~buefy/src/scss/buefy';

@import '@/scss/_spacing.scss';
@import '@/scss/_custom.scss';
@import '@/scss/_widget.scss';
</style>
